@if (centered) {
  <div class="flex flex-col items-center justify-center py-8">
    <img 
      src="assets/images/camspinner-2.svg" 
      alt="Loading" 
      class="spinner-image"
      [style.width.px]="diameter" 
      [style.height.px]="diameter" />
    @if (message) {
      <p class="mt-4 text-sm text-slate-500">{{ message | translate }}</p>
    }
  </div>
} @else {
  <img 
    src="assets/images/camspinner-2.svg" 
    alt="Loading" 
    class="spinner-image inline-block"
    [style.width.px]="diameter" 
    [style.height.px]="diameter" />
}
